import merge from "lodash/merge";
import api from "./api";
import config from "../config";

export default {
  fetchSettings(token) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `event_buckets/${config.event_bucket}`,
          qs: token ? { token: token } : undefined
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchEventBuckets(token) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `event_buckets/active`,
          qs: token ? { token: token } : undefined
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  unlock(token, password) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `event_buckets/${config.event_bucket}/unlock`,
          json: {
            token: token,
            password: password
          }
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  isSundanceMobileMode(tenant) {
    if (!tenant || !tenant.sundance_login) return false;

    const url = new URL(window.location.href);

    const mobileModeParam = url.searchParams.get("mobile") === "true";

    // if the mobile=true query param exists, set it to localStorage
    if (mobileModeParam) {
      window.localStorage.setItem("eventive-hideHeader", true);
    }

    const mobileModeStored =
      window.localStorage.getItem("eventive-hideHeader") === "true";

    return mobileModeParam || mobileModeStored;
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/AppUtil.js